import { render, staticRenderFns } from "./PinBlockComponent.vue?vue&type=template&id=dd002c62&scoped=true"
import script from "./PinBlockComponent.vue?vue&type=script&lang=js"
export * from "./PinBlockComponent.vue?vue&type=script&lang=js"
import style0 from "./PinBlockComponent.vue?vue&type=style&index=0&id=dd002c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd002c62",
  null
  
)

export default component.exports